import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import CalculatedValueHelper from '@sharedCR/common/CalculatedValueHelper';
import PropTypes from 'prop-types';

import { currencyOptions } from 'constants/loanFee';
import { formatNumberToCurrencyString } from 'utils/number';

import { selectWireAmountData } from 'store/loanApplications/selectors/closing.selectors';

import { WireAmountHelperTestIds } from './WireAmountHelper.testIds';
import { getWireAmountDifference } from './WireAmountHelper.utils';

const WireAmountHelper = ({ disabled, name, noValidate, onChange, value }) => {
  const { calculatedWireAmount } = useSelector(selectWireAmountData);

  const onRevert = useCallback(() => {
    onChange({
      target: {
        name,
        value: calculatedWireAmount,
        dataset: { novalidate: noValidate },
      },
    });
  }, [calculatedWireAmount, name, noValidate, onChange]);

  const { isNumberDifference, differenceStr } = getWireAmountDifference({
    calculatedWireAmount,
    value,
  });

  if (!isNumberDifference) {
    return null;
  }

  return (
    <CalculatedValueHelper
      isValueStruckThrough
      calculatedValue={formatNumberToCurrencyString(calculatedWireAmount, currencyOptions)}
      differenceLabel={differenceStr}
      isRevertHidden={disabled}
      revertButtonTestId={WireAmountHelperTestIds.REVERT_BUTTON}
      onRevert={onRevert}
    />
  );
};

WireAmountHelper.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  noValidate: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default WireAmountHelper;
